var _this = this,
    _jsxFileName = "/builds/zillow/adtech-product/constellation/zrs-cms-messaging/src/components/feature/connections/NotForSale/ZestimateOffer/ZestimateOfferWrapper.jsx";

import React from 'react';
import PropTypes from 'prop-types';
import { useYieldCallback } from '@zillow/yield-callback';
import { appendQueryParameter, concatWithDelimiter } from '../../../../../utils/stringUtils';
import ZestimateOfferTemplate from './ZestimateOfferTemplate';
import { NewLaneEvent } from '../../../../../eventing/NewLaneEvent';
import { formNewLaneEventPayload } from '../../../../../eventing/newLaneEventPayload';
import { CLICKSTREAM_EVENT_TYPE } from '../../../../../eventing/clickStreamEventSchema';
import { DSP_BRAND, DSP_EXPERIENCE } from '../../../../internal/constants';
import { useOnsiteMessagingImpressionEvent } from '../../../../internal/OnsiteMessageEventingHooks/useOnsiteMessagingImpressionEvent';
import { useOnsiteMessagingIntentToShowEvent } from '../../../../internal/OnsiteMessageEventingHooks/useOnsiteMessagingIntentToShowEvent';
export var ZestimateOffer = function ZestimateOffer(_ref) {
  var titleMarkdownText = _ref.titleMarkdownText,
      subtitleMarkdownText = _ref.subtitleMarkdownText,
      actionText = _ref.actionText,
      priceTitleText = _ref.priceTitleText,
      finePrintTitleText = _ref.finePrintTitleText,
      finePrintBodyText = _ref.finePrintBodyText,
      bodyTooltipText = _ref.bodyTooltipText,
      bodyTooltipLinkText = _ref.bodyTooltipLinkText,
      bodyTooltipLinkUrl = _ref.bodyTooltipLinkUrl,
      standingOfferPrice = _ref.standingOfferPrice,
      gaSurface = _ref.gaSurface,
      gaLocation = _ref.gaLocation,
      gaCategory = _ref.gaCategory,
      gaAction = _ref.gaAction,
      gaTreatment = _ref.gaTreatment,
      gaDisplayCategory = _ref.gaDisplayCategory,
      trackingParameter = _ref.trackingParameter,
      zpid = _ref.zpid,
      actionLink = _ref.actionLink,
      additionalProps = _ref.additionalProps,
      contactFormVersion = _ref.contactFormVersion,
      eventData = _ref.eventData,
      newLaneEventData = _ref.newLaneEventData,
      additionalClickStreamData = _ref.additionalClickStreamData;
  var upsellIdPieces = [gaSurface, gaLocation, gaDisplayCategory, gaTreatment];
  var upsellIdentifier = concatWithDelimiter(upsellIdPieces, '|');
  var signalForTriggerTracking = additionalProps.signalForTriggerTracking;
  var ref = useOnsiteMessagingImpressionEvent({
    eventData: eventData,
    newLaneEventData: newLaneEventData,
    additionalClickStreamData: additionalClickStreamData
  });
  useOnsiteMessagingIntentToShowEvent({
    eventData: eventData,
    newLaneEventData: newLaneEventData,
    additionalClickStreamData: additionalClickStreamData,
    gaEventData: {
      category: gaCategory,
      action: gaAction,
      label: concatWithDelimiter(['Display', upsellIdentifier], '|')
    },
    signalForTriggerTracking: signalForTriggerTracking
  });
  var questionnaireLink = appendQueryParameter(actionLink, trackingParameter, zpid);

  var onHoverCTA = function onHoverCTA() {
    NewLaneEvent({
      brand: DSP_BRAND,
      experience: DSP_EXPERIENCE,
      sharedJsonStr: JSON.stringify(Object.assign({
        event_type: 'interaction',
        interaction_type: 'hover'
      }, eventData))
    }, formNewLaneEventPayload(CLICKSTREAM_EVENT_TYPE.HOVER, newLaneEventData, additionalClickStreamData), {
      category: gaCategory,
      action: gaAction,
      label: concatWithDelimiter(['Hover', upsellIdentifier], '|')
    });
  };

  var onClickUpsellButton = useYieldCallback(function () {
    NewLaneEvent({
      brand: DSP_BRAND,
      experience: DSP_EXPERIENCE,
      sharedJsonStr: JSON.stringify(Object.assign({
        event_type: 'interaction',
        interaction_type: 'click'
      }, eventData))
    }, formNewLaneEventPayload(CLICKSTREAM_EVENT_TYPE.INTERACTION, newLaneEventData, additionalClickStreamData), {
      category: gaCategory,
      action: gaAction,
      label: concatWithDelimiter(['Click', upsellIdentifier], '|')
    });

    if (actionLink) {
      window.open(questionnaireLink, '_blank');
    }
  });

  if (!standingOfferPrice) {
    return null;
  }

  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 117,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(ZestimateOfferTemplate, {
    titleMarkdownText: titleMarkdownText,
    subtitleMarkdownText: subtitleMarkdownText,
    actionLink: actionLink,
    actionText: actionText,
    priceTitleText: priceTitleText,
    finePrintTitleText: finePrintTitleText,
    bodyTooltipText: bodyTooltipText,
    bodyTooltipLinkText: bodyTooltipLinkText,
    bodyTooltipLinkUrl: bodyTooltipLinkUrl,
    standingOfferPrice: standingOfferPrice,
    questionnaireLink: questionnaireLink,
    onClickUpsellButton: onClickUpsellButton,
    onHoverCTA: onHoverCTA,
    finePrintBodyText: finePrintBodyText,
    gaSurface: gaSurface,
    gaLocation: gaLocation,
    gaTreatment: gaTreatment,
    additionalProps: additionalProps,
    contactFormVersion: contactFormVersion,
    trackingParameter: trackingParameter,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 118,
      columnNumber: 13
    }
  }));
};
ZestimateOffer.propTypes = process.env.NODE_ENV !== "production" ? {
  standingOfferPrice: PropTypes.string.isRequired,
  gaSurface: PropTypes.string,
  gaLocation: PropTypes.string,
  gaCategory: PropTypes.string,
  gaDisplayCategory: PropTypes.string,
  gaAction: PropTypes.string,
  gaTreatment: PropTypes.string,
  trackingParameter: PropTypes.string,
  zpid: PropTypes.string,
  actionLink: PropTypes.string,
  titleMarkdownText: PropTypes.string,

  /**
   * Markdown text for the subtitle
   * Enclose any portion with {{}} to get a tooltip on click.
   * Supports only 1 occurrence of tooltip
   * Example: Get started {{by requesting}} a call.
   */
  subtitleMarkdownText: PropTypes.string,
  actionText: PropTypes.string,
  priceTitleText: PropTypes.string,
  finePrintTitleText: PropTypes.string,
  finePrintBodyText: PropTypes.string,
  bodyTooltipText: PropTypes.string,
  bodyTooltipLinkText: PropTypes.string,
  bodyTooltipLinkUrl: PropTypes.string,
  additionalProps: PropTypes.shape({
    property: PropTypes.object,
    viewer: PropTypes.object,
    abadClient: PropTypes.func,
    zatlasEndpoint: PropTypes.string,
    shouldShowcheckBox: PropTypes.bool,
    signalForTriggerTracking: PropTypes.bool
  }),
  contactFormVersion: PropTypes.string,
  // eslint-disable-next-line zillow/react/forbid-prop-types
  eventData: PropTypes.object,
  // eslint-disable-next-line zillow/react/forbid-prop-types
  newLaneEventData: PropTypes.object,
  // eslint-disable-next-line zillow/react/forbid-prop-types
  additionalClickStreamData: PropTypes.object
} : {};
ZestimateOffer.defaultProps = {
  actionLink: '',
  titleMarkdownText: '',
  subtitleMarkdownText: '',
  actionText: '',
  priceTitleText: '',
  finePrintTitleText: '',
  finePrintBodyText: '',
  bodyTooltipText: '',
  bodyTooltipLinkText: '',
  bodyTooltipLinkUrl: '',
  gaCategory: 'Homes',
  gaAction: 'Zillow Offer Upsell',
  gaLocation: '',
  gaSurface: '',
  gaTreatment: '',
  gaDisplayCategory: null,
  trackingParameter: '',
  zpid: null,
  additionalProps: {},
  contactFormVersion: 'estimated-sale-price',
  eventData: {},
  newLaneEventData: {},
  additionalClickStreamData: {}
};